import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function PrintLog({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="Print Transfer Log"
      fullCaption="[STR_TransferLog_Printed].............. 
      [STR_TicketRecord_Line1]..............
      [STR_TicketRecord_Line2]..............
      [STR_TicketRecord_Line3]..............
      [STR_TicketRecord_Line4]..............
      [STR_TicketRecord_Line5]..............
      [STR_TicketRecord_Line6]..............
      [STR_TicketRecord_Line7]..............
      [STR_TicketRecord_Line8]..............
      [STR_TicketRecord_Line9]..............
      "
    />
  );
}

export default PrintLog;
